module.exports = __webpack_public_path__ + "static/media/dumpster-fire.0eca2546.svg";